import { OidReportDetailsHeader } from './OidReportDetailsHeader';

export default OidReportDetailsHeader;
